<rt-dropdown [width]="DropdownWidth.FullWidth" #timeDropdownContainer class="viewport">
  <rt-dropdown-item
    *ngFor="let time of state.timesArr; let i = index; trackBy: trackBy"
    (click)="onTimeSelect(i)"
    [class.active]="i === state.selectionIndex"
    #timeItemsQuery
    class="time-dropdown-item"
  >
    <span>{{ time }}</span>
  </rt-dropdown-item>
</rt-dropdown>
